/**
 * DAT-906 · How another surface (the wage breakdown of an agency shift) asks the Team page to open on the
 * Agency Configuration tab. Shape of `WageSettings/deepLink.ts`: the tab is local state, not URL-backed
 * filter state, so Team applies the param once and strips it.
 */

export const TEAM_AGENCY_CONFIGURATION_PARAM = "agency_configuration";

const TEAM_AGENCY_CONFIGURATION_VALUE = "true";

export function buildTeamAgencyConfigurationUrl(departmentId: string): string {
	return `/${departmentId}/team?${TEAM_AGENCY_CONFIGURATION_PARAM}=${TEAM_AGENCY_CONFIGURATION_VALUE}`;
}

export function isTeamAgencyConfigurationRequested(params: URLSearchParams): boolean {
	return params.get(TEAM_AGENCY_CONFIGURATION_PARAM) === TEAM_AGENCY_CONFIGURATION_VALUE;
}
